import React, {} from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { isSuccess, ResourcesItem } from 'redux-and-the-rest';

import { getOrFetchGame } from '../../redux/reducers/gameReducer';
import { ApplicationState } from '../../redux/types';
import { GameModel } from '../../models/gameModel';
import LoadingIndicator from '../shared/LoadingIndicator';
import Game from './Game';

import './GamesViewScreen.scss';

interface Props {
  game: ResourcesItem<GameModel>;
  islandId: string;
}

const GamesViewScreen = ({
  game, islandId,
}: Props): React.ReactElement => {
  if (!isSuccess(game)) {
    return <LoadingIndicator />;
  }

  return (
    <Game game={game.values} islandId={islandId} />
  );
};

const mapStateToProps = (
  { games }: ApplicationState,
  { match: { params: { gameId, islandId } } }: RouteComponentProps<{ gameId: string; islandId: string; }>,

) => ({
  islandId,
  game: getOrFetchGame(games, { id: gameId }),
});

export default withRouter(connect(mapStateToProps)(GamesViewScreen));
